'use strict';

import React from 'react';
import { Modal } from 'react-bootstrap';

require('styles//ContactForm.css');

class Banner extends React.Component {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.click = this.click.bind(this);

    this.state = {
      showModal: true
    }
  }

  close() {
    this.setState({ showModal: false });
  }

  click() {
    this.setState({ showModal: false });
    window.setTimeout(() => {document.getElementById('solutions').scrollIntoView()}, 0);
  }

  open() {
    this.setState({ showModal: true });
  }


  render() {
    return (
      <div>
        <Modal className="banner-modal" show={this.state.showModal} onHide={this.close} onClick={this.close}>
          <Modal.Body onClick={this.close}>
            <button className="close" onClick={this.close}>Fechar</button>
            <a href="https://aurea219.pt/">
              <img src="/static/images/banner/desktop-ubereats.png" alt="Aurea 219" className="desktop"/>
              <img src="/static/images/banner/phone-ubereats.png" alt="Aurea 219" className="phone"/>
            </a>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

Banner.displayName = 'Banner';

// Uncomment properties you need
// ContactFormComponent.propTypes = {};
// ContactFormComponent.defaultProps = {};

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner.js